const conf = {
  // serverUrl: 'http://103.125.216.56:8029', //http://103.125.216.56:8035
  serverUrl: window.location.hostname === "localhost1" || window.location.hostname === "103.125.216.56" ? `http://103.125.216.56:8022`: 'https://service.alphafacilities.com.au',
  // serverUrl: 'https://service.alphafacilities.com.au',
  basePath: 'api/v1',
  port: 80
};

export default conf;
